const searchList = document.querySelector('.search-results');

if (searchList) {
  /* ----------------------------------------
   * Helpers
   * ------------------------------------- */

  const searchInput = searchList.querySelector('.mod-filter .mod-input__field');
  if (searchInput) {
    const loaderToggle = (toggle) => {
      searchList.classList.toggle('show-loader', toggle);
    };

    const MIN_LENGTH = 3;

    // Update URL parameters
    const updateUrl = ({ searchTerm, pageNumber }) => {
      const [baseUrl] = window.location.href.split('?');
      const params = new URLSearchParams();
      if (searchTerm) params.set('searchTerm', searchTerm);
      if (pageNumber && pageNumber !== '1') params.set('pageNumber', pageNumber);
      window.history.pushState({}, '', `${baseUrl}?${params.toString()}`);
    };

    const validateInput = (value) => {
      const filterInput = searchInput.closest('.mod-input');
      filterInput.querySelector('.fv-plugins-message-container')?.remove();
      const getErrorMsg =
        searchInput.getAttribute('data-fv-not-empty___message') || `Please enter at least ${MIN_LENGTH} characters.`;

      if (!value || value.trim().length < MIN_LENGTH) {
        filterInput.classList.add('is-validation-failed');
        filterInput.insertAdjacentHTML('beforeend', `<div class="fv-plugins-message-container">${getErrorMsg}</div>`);
        return false;
      }

      filterInput.classList.remove('is-validation-failed');
      return true;
    };

    searchInput.addEventListener('input', () => {
      const value = searchInput.value.trim();

      if (value.length >= MIN_LENGTH) {
        const wrapper = searchInput.closest('.mod-input');
        wrapper?.querySelector('.fv-plugins-message-container')?.remove();
        wrapper?.classList.remove('is-validation-failed');
      }
    });

    /* ----------------------------------------
     * Axios
     * ------------------------------------- */

    const fetchSearchList = async ({ pageNumber = '1', searchTerm = '' }) => {
      if (!validateInput(searchTerm)) return;

      // const SITE_KEY = searchList.dataset.sitekey;
      const action = 'getSearchList';

      const listInner = searchList.querySelector('.search-results__right-inner');
      const paginationInner = searchList.querySelector('.search-results__footer');
      const notFound = searchList.querySelector('.search-results__no-result');

      if (listInner) listInner.innerHTML = '';
      paginationInner?.classList.add('hide');
      notFound?.classList.add('hide');

      loaderToggle(true);
      try {
        /* ----------------------------------------
         * CAPTCHA + NONCE (INLINE)
         * ------------------------------------- */

        if (!window.grecaptcha) {
          throw new Error('reCAPTCHA is not loaded');
        }

        const token = await grecaptcha.execute(localData.captchaSiteKey, { action });
        const nonce = await getNonceForAction(action);

        /* ----------------------------------------
         * AJAX REQUEST
         * ------------------------------------- */

        const { data } = await axios.post(localData.siteURL, {
          action,
          nonce,
          token,
          searchTerm,
          pageNumber,
          id: localData.id,
          lang: localData.lang,
        });

        /* ----------------------------------------
         * No Results Case / Results Case / Pagination Case
         * ------------------------------------- */

        // No rasults
        const list = data?.data?.html_list;
        const pagination = data?.data?.html_pagination;

        if (Array.isArray(list) && list.length === 0) {
          notFound?.classList.remove('hide');
          paginationInner?.classList.add('hide');
        } else if (typeof list === 'string' && list.length > 0) {
          notFound?.classList.add('hide');
          paginationInner?.classList.remove('hide');
          listInner.innerHTML = list;
          paginationInner.innerHTML = pagination || '';
        }

        // Update URL + scroll
        updateUrl({ searchTerm, pageNumber });
        searchList.scrollIntoView();
      } catch (error) {
        console.error(error);
      } finally {
        loaderToggle(false);
      }
    };

    /* ----------------------------------------
     * Search Submission Handler
     * ------------------------------------- */

    const submitSearch = () => {
      fetchSearchList({
        pageNumber: '1',
        searchTerm: searchInput.value.trim(),
      });
    };

    /* ----------------------------------------
     * Events
     * ------------------------------------- */

    // Search button click

    attachEvent('.search-results .search_button', 'click', (ev) => {
      ev.preventDefault();
      submitSearch();
    });

    searchInput.addEventListener('keydown', (ev) => {
      if (ev.key === 'Enter') {
        ev.preventDefault();
        submitSearch();
      }
    });

    // Pagination click
    attachEvent('.search-results .page-numbers', 'click', (ev) => {
      ev.preventDefault();

      const page = ev.target.closest('.page-numbers')?.dataset.page || '1';

      fetchSearchList({
        pageNumber: page,
        searchTerm: searchInput.value,
      });
    });

    /* ----------------------------------------
     * Browser Back/Forward Support
     * ------------------------------------- */

    window.addEventListener('popstate', () => {
      const params = new URLSearchParams(window.location.search);

      const searchTerm =
        params.get('searchTerm') ||
        params.get('header_search_input') ||
        params.get('menu_search_input') ||
        params.get('search_term') ||
        '';

      const pageNumber = params.get('pageNumber') || '1';

      // Update input value
      if (searchInput) {
        searchInput.value = searchTerm;
      }

      // Only fetch if searchTerm is valid
      if (searchTerm.trim().length >= MIN_LENGTH) {
        fetchSearchList({
          pageNumber,
          searchTerm: searchTerm.trim(),
        });
      }
    });

    /* ----------------------------------------
     * Load from URL (Initial Page Load)
     * ------------------------------------- */

    const params = new URLSearchParams(window.location.search);
    const initialSearch =
      params.get('searchTerm') ||
      params.get('header_search_input') ||
      params.get('menu_search_input') ||
      params.get('search_term') ||
      '';

    if (initialSearch) {
      searchInput.value = initialSearch;
    }
  }
}
